import React from "react"
import Slider from "react-slick";
import {Link} from 'react-router-dom'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BannerSliderTwo() {
    var settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      };
  return (
    <div>
    <div className="banner style_two">
        <Slider {...settings} className="banner_slider">
            <div className="slide-item section-bg" >
                <div className="banner_text section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/banner/1.png)' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="inner">
                                    <h1 className="title">Get <span className="thm-color-one">Motivated</span></h1>
                                    <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, </p>
                                </div>
                                <div className="video_btn text-center">
                                    <Link to="https://www.youtube.com/watch?v=TKnufs85hXk" className="popup-video">
                                        <i className="fas fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="slide-item section-bg" >
                <div className="banner_text section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/banner/2.jpg)' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="inner">
                                    <h1 className="title">Get <span className="thm-color-one">Motivated</span></h1>
                                    <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, </p>
                                </div>
                                <div className="video_btn text-center">
                                    <Link to="https://www.youtube.com/watch?v=TKnufs85hXk" className="popup-video">
                                        <i className="fas fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="slide-item section-bg" >
                <div className="banner_text section-bg" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/banner/3.jpg)' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="inner">
                                    <h1 className="title">Get <span className="thm-color-one">Motivated</span></h1>
                                    <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, </p>
                                </div>
                                <div className="video_btn text-center">
                                    <Link to="https://www.youtube.com/watch?v=TKnufs85hXk" className="popup-video">
                                        <i className="fas fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Slider>
        {/* <div className="banner_arrow_dots container">
            <i className="fal fa-chevron-left slick-arrows slick-prev"></i>
            <div className="banner_dots"></div>
            <i className="fal fa-chevron-right slick-arrows slick-next"></i>
        </div> */}
    </div>
    </div>
  )
}

export default BannerSliderTwo